// src/paywit.ts
var PaywitError = class extends Error {
  constructor(status, message, body) {
    super(message);
    this.name = "PaywitError";
    this.status = status;
    this.body = body;
  }
};
function resolveApiBaseUrl(explicit) {
  if (explicit) {
    return explicit;
  }
  if (typeof window !== "undefined") {
    const global = window.__PAYWIT_API_BASE_URL__;
    if (typeof global === "string") {
      return global;
    }
  }
  return "https://api.paywit.xyz";
}
var Paywit = class {
  constructor(config) {
    if (!config.publishableKey) {
      throw new Error("Paywit: publishableKey is required");
    }
    this.publishableKey = config.publishableKey;
    this.apiBaseUrl = resolveApiBaseUrl(config.apiBaseUrl);
  }
  async request(path, options = {}) {
    const res = await fetch(`${this.apiBaseUrl}${path}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        "X-Paywit-Publishable-Key": this.publishableKey,
        ...options.headers
      }
    });
    if (!res.ok) {
      const text = await res.text();
      let message = `Paywit API error (${res.status})`;
      try {
        const parsed = JSON.parse(text);
        const detail = parsed?.body?.message ?? parsed?.message ?? parsed?.Message;
        if (typeof detail === "string" && detail.trim()) {
          message = detail.trim();
        }
      } catch {
      }
      throw new PaywitError(res.status, message, text);
    }
    return res.json();
  }
  async createPayment(params) {
    if (params.amount == null || params.amount <= 0) {
      throw new Error("Paywit: amount must be a positive number");
    }
    return this.request(
      "/v1/payments",
      {
        method: "POST",
        body: JSON.stringify({
          amount: params.amount,
          description: params.description,
          clientReferenceId: params.clientReferenceId,
          returnUrl: params.returnUrl
        })
      }
    );
  }
  /**
   * Fetch the current state of a payment (status, amount, etc.).
   * Useful for polling after the buyer is sent to checkout. Throws `PaywitError` on failure.
   */
  async getPayment(paymentId) {
    if (!paymentId) {
      throw new Error("Paywit: paymentId is required");
    }
    const res = await this.request(
      `/v1/payments/${encodeURIComponent(paymentId)}`,
      { method: "GET" }
    );
    return res.payment;
  }
  openCheckout(checkoutUrl) {
    if (!checkoutUrl) {
      throw new Error("Paywit: checkoutUrl is required");
    }
    if (typeof window === "undefined") {
      throw new Error("Paywit: openCheckout is only available in browser environments");
    }
    window.open(checkoutUrl, "_blank", "noopener,noreferrer");
  }
};
export {
  Paywit,
  PaywitError
};
